/**
 * httpsのURLとして解釈できる場合のみ、新規タブで開く
 *
 * @param {string} url
 * @returns {boolean} URLが有効（httpsとして解釈可能）な場合は true
 * ※ 実際にタブを開けたか（ポップアップブロック等）は保証しない
 */
export const openLinkInNewTab = (url) => {
  if (!url) return false;

  const safeUrl = getSafeUrl(url);
  if (!safeUrl) return false;

  window.open(safeUrl, "_blank", "noopener,noreferrer");
  return true;
};

/**
 * URLを検証し、httpsの場合のみ正規化されたURLを返す
 *
 * @param {string} url
 * @returns {string|null} 安全なURL or null
 */
const getSafeUrl = (url) => {
  try {
    const parsedUrl = new URL(url, window.location.href);

    if (parsedUrl.protocol !== "https:") {
      return null;
    }

    return parsedUrl.href;
  } catch {
    return null;
  }
};
